var SupportCancelOrderServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportCancelOrderServiceActionView = (function(superClass) {
  extend(SupportCancelOrderServiceActionView, superClass);

  function SupportCancelOrderServiceActionView() {
    return SupportCancelOrderServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportCancelOrderServiceActionView.prototype.id = 'cancel_order';

  SupportCancelOrderServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportCancelOrderServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportCancelOrderServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: 'cancel_order',
      service_action: I18n.t("js.modules.support.cancel_order")
    };
    return this.extendHash(hash);
  };

  SupportCancelOrderServiceActionView.prototype.actionHandler = function(event) {
    var dealPermalink, orderId, url;
    dealPermalink = Groupon.Support.currentOrder.deal.id;
    orderId = Groupon.Support.currentOrder.id;
    url = "/deals/" + dealPermalink + "/confirmation/" + orderId + "#toggle-inputs";
    return openLocation(url);
  };

  SupportCancelOrderServiceActionView.prototype.events = {
    "click #cancel_order": "actionHandler"
  };

  return SupportCancelOrderServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportCancelOrderServiceActionView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvY2FuY2VsX29yZGVyX3NlcnZpY2VfYWN0aW9uLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL29yZGVyX3JlbGF0ZWQvc2VydmljZV9hY3Rpb25zL2NhbmNlbF9vcmRlcl9zZXJ2aWNlX2FjdGlvbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSxzR0FBQTtFQUFBOzs7QUFBQSw2QkFBQSxHQUFnQyxPQUFBLENBQVEsdUJBQVI7O0FBQ2hDLGtDQUFBLEdBQXFDLE9BQUEsQ0FBUSxpREFBUjs7QUFFL0I7Ozs7Ozs7Z0RBQ0osRUFBQSxHQUFJOztnREFFSixVQUFBLEdBQVksU0FBQTtJQUNWLENBQUMsQ0FBQyxPQUFPLENBQUMsS0FBVixDQUFnQixDQUFoQixFQUFtQixDQUFDLElBQUQsQ0FBTSxDQUFDLE1BQVAsQ0FBYyxDQUFDLENBQUMsU0FBRixDQUFZLElBQVosQ0FBZCxDQUFuQjtJQUNBLElBQUMsQ0FBQSxTQUFELEdBQWE7SUFDYixJQUFDLENBQUEsUUFBRCxHQUFZO1dBQ1osSUFBQyxDQUFBLEtBQUQsR0FBUyxPQUFPLENBQUMsT0FBTyxDQUFDO0VBSmY7O2dEQU1aLE1BQUEsR0FBUSxTQUFBO1dBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBbEIsRUFBNkIsSUFBQyxDQUFBLFNBQTlCLENBQVo7RUFETTs7Z0RBR1IsTUFBQSxHQUFRLFNBQUE7QUFDTixRQUFBO0lBQUEsSUFBQSxHQUNFO01BQUEsaUJBQUEsRUFBb0IsY0FBcEI7TUFDQSxjQUFBLEVBQWlCLElBQUksQ0FBQyxDQUFMLENBQU8saUNBQVAsQ0FEakI7O1dBRUYsSUFBQyxDQUFBLFVBQUQsQ0FBWSxJQUFaO0VBSk07O2dEQU1SLGFBQUEsR0FBZSxTQUFDLEtBQUQ7QUFDYixRQUFBO0lBQUEsYUFBQSxHQUFnQixPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUM7SUFDbEQsT0FBQSxHQUFVLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBWSxDQUFDO0lBQ3ZDLEdBQUEsR0FBTSxTQUFBLEdBQVcsYUFBWCxHQUEwQixnQkFBMUIsR0FBMkMsT0FBM0MsR0FBb0Q7V0FFMUQsWUFBQSxDQUFhLEdBQWI7RUFMYTs7Z0RBT2YsTUFBQSxHQUNFO0lBQUEscUJBQUEsRUFBd0IsZUFBeEI7Ozs7O0dBMUI4Qzs7QUE0QmxELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
